import { Component, EventEmitter, inject, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomModalService } from '@piqet-angular/shared';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent {
  isTermsAndCondition!: boolean | any;
  isVerification: any;
  granted: string = 'granted';
  denied: string = 'denied';
  pdfFileUrl: any;
  localPdf: string = './assets/PIQET_Updated_Terms.pdf';
  myOrganizationService = inject(MyOrganizationService);
  toaster = inject(ToastrService);
  modal = inject(CustomModalService);
  @Output() saveImageRightAuth = new EventEmitter<any>();
  pdfDoc: any;
  constructor(private sanitizer: DomSanitizer) {
    this.isTermsAndCondition =
      this.modal?.modalService?.config?.initialState?.['isTermsAndCondition'];
    this.pdfDoc = this.modal?.modalService?.config?.initialState?.['pdfDoc'];
    this.isVerification = this.modal?.modalService?.config?.initialState?.['isVerification'];
    this.pdfFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.isVerification ? this.pdfDoc : this.localPdf
    );
  }

  onClose() {
    this.modal.close();
  }

  onSave(permissionType: string) {
    const isGranted = permissionType === this.granted;

    this.saveImageRightAuth.emit(isGranted);
    this.myOrganizationService.updateOrgImageConsent(isGranted).subscribe((res: any) => {
      !res.messageType ? this.toaster.success(res.message) : this.toaster.error(res.message);
    });
    this.onClose();
  }

  openTermsAndConditions() {
    window.open('assets/PIQET_Updated_Terms.pdf', '_blank');
  }
}
